type StatusTone = "info" | "success" | "error";

type StatusMessageProps = {
  title?: string;
  message: string;
  tone?: StatusTone;
};

const toneClasses: Record<StatusTone, string> = {
  info: "border-line bg-white text-graphite",
  success: "border-pine/20 bg-mint text-pine",
  error: "border-red-900/20 bg-red-50 text-red-900",
};

export function StatusMessage({
  title,
  message,
  tone = "info",
}: StatusMessageProps) {
  return (
    <div className={`rounded-md border p-4 text-sm ${toneClasses[tone]}`}>
      {title ? <p className="font-semibold">{title}</p> : null}
      <p className={title ? "mt-1 leading-6" : "leading-6"}>{message}</p>
    </div>
  );
}
